import { Component } from '@angular/core';
import { ServicesService } from 'src/services/services.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';

@Component({
  selector: 'app-payment-setting',
  templateUrl: './payment-setting.component.html',
  styleUrls: ['./payment-setting.component.scss'],
  standalone: false
})
export class PaymentSettingComponent {
  message!: string;
  imagePath: any;
  imagefileURL!: any | ArrayBuffer;
  imgType!: any | ArrayBuffer;
  setting_data: any
  name: any;
  razorpay_key: any;
  razorpay_secret: any;
  payment_option: any;
  upi_id: any;

  constructor(
    private service: ServicesService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private location: Location,
    private router: Router
  ) { }

  previewpimage(files: any) {
    if (files.length === 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagefileURL = reader.result;
      this.imgType = 'payment_logo';
      this.service.uploadimage(this.imagefileURL, this.imgType).subscribe((data: any) => {
        this.imagePath = data['image_name'];
      });
    };
  }

  ngOnInit() {
    const eventId = sessionStorage.getItem('Event_ID');
    this.get_PaymentSetting(eventId);

  }

  get_PaymentSetting(event_id: any) {
    this.service.getPaymentSetting(event_id).subscribe(
      (data: any) => {
        this.setting_data = data.data;
        this.name = this.setting_data[0].name;
        this.razorpay_key = this.setting_data[0].razorpay_key;
        this.razorpay_secret = this.setting_data[0].razorpay_secret;
        this.imagePath = this.setting_data[0].image;
        this.payment_option = this.setting_data[0].payment_option;
        this.upi_id = this.setting_data[0].upi_id;

      });
  }

  Update_setting() {
    const setting = {
      name: this.name,
      razorpay_key: this.razorpay_key,
      razorpay_secret: this.razorpay_secret,
      image: this.imagePath,
      payment_option: this.payment_option,
      upi_id: this.upi_id
    }

    this.service.editPaymentSetting(setting).subscribe(
      (data: any) => {
        this.toastr.success("Setting Updated Succesfully");
      }
    )
  }
}
